import Service, { ServiceConfig } from '../Service'

import { eventEmitter } from '../../decorators'
import { EventEmitterInterface } from '../../utils/EventEmitter'
import Auth from './Auth'
import Core from './Core'
import FS from './FS'
import PG from './PG'
import PGManager from './PGManager'

// export interface ClientConfig extends ServiceConfig {}

@eventEmitter
export default class Client extends Service implements EventEmitterInterface {
  public readonly auth: Auth
  public readonly pg: PG
  public readonly pgManager: PGManager
  public readonly fs: FS
  public readonly core: Core

  constructor(config: ServiceConfig) {
    super(config)

    this.auth = new Auth(this)
    this.pg = new PG(this)
    this.pgManager = new PGManager(this)
    this.fs = new FS(this)
    this.core = new Core(this)
  }

  // EventEmitter interface implementation
  on(event: string, listener: (...args: any[]) => void): void {
    return
  }
  removeListener(event: string, listener: (...args: any[]) => void): void {
    return
  }
  emit(event: string, ...args: any[]): void {
    return
  }
  once(event: string, listener: (...args: any[]) => void): void {
    return
  }
}
